/**
 * Aligne la langue du compte (e-mails, notifications) sur un choix de langue
 * explicite de l'utilisateur connecté. Fire-and-forget : ne bloque jamais la
 * navigation ; keepalive protège la requête quand la bascule de locale passe
 * par un rechargement complet de la page (fallback window.location).
 *
 * Après succès, force NextAuth à re-fetcher la session pour que
 * session.user.language reflète le nouveau choix (même astuce
 * visibilitychange que le formulaire /account).
 *
 * La vérification « utilisateur connecté » reste à la charge de l'appelant
 * (useSession ou prop session selon le composant).
 */
export function syncAccountLanguage(newLocale) {
    fetch("/api/user/put/language", {
        method: "put",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ language: newLocale }),
        keepalive: true,
    })
        .then((response) => {
            if (response.ok) {
                document.dispatchEvent(new Event("visibilitychange"));
            }
        })
        .catch(() => {});
}
